module.exports = __webpack_public_path__ + "img/materials-enter.36f79021.svg";